import { render, staticRenderFns } from "./send1.vue?vue&type=template&id=6b29b61a&scoped=true&"
import script from "./send1.vue?vue&type=script&lang=js&"
export * from "./send1.vue?vue&type=script&lang=js&"
import style0 from "./send1.vue?vue&type=style&index=0&id=6b29b61a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b29b61a",
  null
  
)

export default component.exports